module.exports = __webpack_public_path__ + "img/car-main.1a321e7.webp";